import LoadingSpinner from 'components/group-workout/loading-spinner'
import { useCurrentGroupWorkoutSession, useGroupWorkoutSessionActions } from 'store/group-workout-session/selectors'
import DynamicLink from './link'
import Bag from './bag'
import { getCurrentConnectionIssue } from 'lib/connection/connection'

const colors: string[] = [
  '#2C89C8',
  '#70ED99',
  '#FF7733',
  '#7E68AE',
  '#F7D126',
  '#F04D26',
  '#00AFB9',
  '#7857FF',
  '#F9383B',
  '#006BE8',
]

const BagSetup = () => {
  const { toggleGroupBagEnabled } = useGroupWorkoutSessionActions()
  const groupWorkoutSession = useCurrentGroupWorkoutSession()

  return (
    <div>
      {!groupWorkoutSession ? (
        <div style={{ padding: '2rem 0' }}>
          <LoadingSpinner />
        </div>
      ) : (
        <div
          style={{
            display: 'flex',
            gap: '1rem',
            padding: '2rem 0',
            maxWidth: '80vw',
            width: 'fit-content',
          }}
        >
          {groupWorkoutSession.groupBags.map((bagData, index) => {
            const connectionStatus = getCurrentConnectionIssue({
              latestWifiStrength: bagData?.bag?.latestWifiStrength ?? null,
              averageReceivedPackets: bagData?.bag?.averageReceivedPackets ?? null,
              latestRebootCount: bagData?.bag?.latestRebootCount ?? null,
            }).status

            return (
              <div key={bagData.id + 'group'} style={{ textAlign: 'center' }}>
                <div onClick={() => toggleGroupBagEnabled(bagData.id)} key={bagData.id + 'container'}>
                  <Bag color={colors[index]} opacity={bagData.isEnabled ? 1 : 0.4} />
                </div>
                <div
                  style={{
                    display: 'flex',
                    justifySelf: 'center',
                    WebkitJustifyContent: 'center',
                  }}
                >
                  <DynamicLink status={connectionStatus} />
                </div>
              </div>
            )
          })}
        </div>
      )}
    </div>
  )
}

export default BagSetup
